module.exports = __webpack_public_path__ + "resources/img/img_appen_data1_en.9b61d45be7cddb20eb9266cbb33fcfb1.png";